"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlOnboardingExtraDataTypes = void 0;
const CommonOnboardingExtraDataTypes_1 = require("../../common/domain/CommonOnboardingExtraDataTypes");
const HlOnboardingDataTypeId_1 = require("./HlOnboardingDataTypeId");
const keyedRecord_1 = require("../../infrastructure/keyedRecord");
const PaymentPlanExtraData_1 = require("./payment-plan/PaymentPlanExtraData");
exports.HlOnboardingExtraDataTypes = Object.assign({}, CommonOnboardingExtraDataTypes_1.CommonOnboardingExtraDataTypes, (0, keyedRecord_1.keyedRecord)()({
    [HlOnboardingDataTypeId_1.HlOnboardingDataTypeId.HL_PAYMENT_PLAN]: PaymentPlanExtraData_1.PaymentPlanExtraData,
}));
//# sourceMappingURL=HlOnboardingExtraDataTypes.js.map